export const TipType = Object.freeze({
  Percentage: 'percentage',
  Amount: 'amt',
});

// driver tips (for DELIVERY)
export const DriverTips = Object.freeze({
  ten: { cents: null, coeff: 0.1, text: '10%' },
  fifteen: { cents: null, coeff: 0.15, text: '15%' },
  twenty: { cents: null, coeff: 0.2, text: '20%' },
  other: { cents: 0, coeff: null, text: 'Other' },
});

// store tips (for PICKUP)
export const StoreTips = Object.freeze({
  ten: { tips: 10, tipsamt: 0, tipstype: TipType.Percentage, text: '10%' },
  fifteen: { tips: 15, tipsamt: 0, tipstype: TipType.Percentage, text: '15%' },
  twenty: { tips: 20, tipsamt: 0, tipstype: TipType.Percentage, text: '20%' },
  other: { tips: 0, tipsamt: 0, tipstype: TipType.Amount, text: 'Other' },
});
